<template>
    <div class="global-search-box" :class="isSearchBoxOpen? 'opened': 'closed'">
        <div v-if="!isSearchBoxOpen">
            <img
                class="search-icon"
                alt="Search icon"
                @click="toggleSearchOpenAndClose(true)"
                src="https://objects.kaxmedia.com/auto/o/139789/b1b2beb960.svg"
                width="20" height="20"
            >
        </div>
        <div v-else>
            <span v-if="searchValue.length > 0"
                  class="search-input-close-label"
                  :class="isUserBusySearching? 'd-block': ''"
                  @click="clearSearchValue()">
                {{ translations.clear }}</span>

            <svg class="search-input-close-icon"
                 :class="isUserBusySearching? 'd-block': ''"
                 @click="toggleSearchOpenAndClose(false)"
                 width="20px" height="20px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <polygon id="path-1" points="0 0 20 0 20 19.9998 0 19.9998"></polygon>
                </defs>
                <g id="Icons/Illustrations" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Icon/Cross-Circle/Grey" transform="translate(-5.000000, -5.000000)">
                        <g id="Group-6" transform="translate(4.999800, 5.000000)">
                            <mask id="mask-2" fill="white">
                                <use xlink:href="#path-1"></use>
                            </mask>
                            <g id="Clip-5"></g>
                            <path
                                d="M13.694,12.216 C14.102,12.624 14.102,13.286 13.694,13.694 C13.286,14.102 12.625,14.102 12.217,13.694 L10,11.477 L7.784,13.694 C7.376,14.102 6.714,14.102 6.306,13.694 C5.898,13.286 5.898,12.624 6.306,12.216 L8.523,10 L6.306,7.783 C5.898,7.375 5.898,6.714 6.306,6.306 C6.714,5.898 7.376,5.898 7.784,6.306 L10,8.522 L12.217,6.306 C12.625,5.898 13.286,5.898 13.694,6.306 C14.102,6.714 14.102,7.375 13.694,7.783 L11.478,10 L13.694,12.216 Z M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 L10,0 Z"
                                id="Fill-4" fill="#777777" mask="url(#mask-2)"></path>
                        </g>
                    </g>
                </g>
            </svg>

            <ais-instant-search :search-client="searchClient" :index-name="searchIndex" :middlewares="middlewares">
                <!-- maximum search result items/hits (1000 is max on algolia) -->
                <ais-configure :hits-per-page.camel="500" :click-analytics.camel="true"/>

                <ais-search-box>
                    <template slot-scope="{ refine }">
                        <input
                            ref="search"
                            class="search-input"
                            type="search"
                            autocorrect="off"
                            autocapitalize="off"
                            autocomplete="off"
                            spellcheck="false"
                            required="required"
                            maxlength="100"
                            aria-label="Search"
                            :placeholder="translations.placeholder"
                            v-model="searchValue"
                            @input="refineSearch(refine, $event.currentTarget.value)"
                        >
                        <button type="submit" title="Search" class="ais-SearchBox-submit">
                            <svg class="search-input-icon" height="20" viewBox="0 0 20 20" width="20"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="m12.5 11h-.79l-.28-.27c.98-1.14 1.57-2.62 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99 1.49-1.49zm-6 0c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
                                    fill="#777"
                                >
                                </path>
                            </svg>
                        </button>
                    </template>
                </ais-search-box>
                <ais-state-results>
                    <template v-slot="{ results: { hits,query }}">
                        <div id="js-search-result"
                             class="search-result scroller"
                             @scroll="onSearchResultScroll"
                             v-show="query.length > 0 && searchValue.length > 0">
                            <span class="total-items" v-if="showFooter">
                                {{ itemsFiltered.length }} {{ translations.total_search_results }}
                            </span>
                            <ais-hits v-if="resultsCheck(hits, query)">
                                <template v-slot="{ items, sendEvent }">
                                    <ul id="js-search-list" class="search-list">
                                        <li v-for="item in items" :key="item.objectID">
                                            <a
                                                :href="item.path"
                                                @click="sendEvent('click', item, 'Item Link Clicked'),trackSearchItemClick(query, item)"
                                            >
                                                {{ item.title }}
                                            </a>
                                        </li>
                                    </ul>
                                    <div v-if="showFooter" class="footer d-flex">
                                        <div v-if="itemsFiltered.length > 0" class="flex-fill"
                                             @click="scrollPrev" :class="{'opacity-0': !showScrollPrev}">
                                            <svg width="16px" height="10px" viewBox="0 0 16 10" version="1.1"
                                                 xmlns="http://www.w3.org/2000/svg"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <defs>
                                                    <polygon id="path-1" points="0 0 16 0 16 9.9996 0 9.9996"></polygon>
                                                </defs>
                                                <g id="Icons/Illustrations" stroke="none" stroke-width="1" fill="none"
                                                   fill-rule="evenodd">
                                                    <g id="Icon/Up-Arrow/Grey"
                                                       transform="translate(-7.000000, -10.000000)">
                                                        <g id="Group-6" transform="translate(7.000000, 10.000000)">
                                                            <mask id="mask-2" fill="white">
                                                                <use xlink:href="#path-1"></use>
                                                            </mask>
                                                            <g id="Clip-5"></g>
                                                            <path
                                                                d="M8.503,0.1096 C8.661,0.1836 8.811,0.2996 8.953,0.4586 L15.661,7.8036 C15.887,8.0516 16,8.3536 16,8.7106 C16,8.9396 15.946,9.1536 15.84,9.3506 C15.733,9.5476 15.59,9.7056 15.412,9.8236 C15.234,9.9406 15.032,9.9996 14.806,9.9996 C14.48,9.9996 14.188,9.8666 13.933,9.5986 L8,3.0566 L2.067,9.5986 C1.817,9.8666 1.526,9.9996 1.194,9.9996 C0.974,9.9996 0.773,9.9406 0.592,9.8236 C0.411,9.7056 0.267,9.5476 0.16,9.3506 C0.053,9.1536 0,8.9396 0,8.7106 C0,8.3536 0.113,8.0516 0.338,7.8036 L7.047,0.4586 C7.189,0.3056 7.338,0.1906 7.492,0.1146 C7.647,0.0386 7.816,-0.0004 8,-0.0004 C8.178,-0.0004 8.346,0.0366 8.503,0.1096"
                                                                id="Fill-4" fill="#777777" mask="url(#mask-2)"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                        <div v-if="itemsFiltered.length > 0 " class="flex-fill"
                                             @click="scrollNext" :class="{'opacity-0': !showScrollNext}">
                                            <svg width="16px" height="10px" viewBox="0 0 16 10"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <defs>
                                                    <polygon id="path-1" points="0 0 16 0 16 9.9996 0 9.9996"></polygon>
                                                </defs>
                                                <g id="Icons/Illustrations" stroke="none" stroke-width="1" fill="none"
                                                   fill-rule="evenodd">
                                                    <g id="Icon/Down-Arrow/Grey"
                                                       transform="translate(-7.000000, -10.000000)">
                                                        <g id="Group-6" transform="translate(6.999900, 10.000000)">
                                                            <mask id="mask-2" fill="white">
                                                                <use xlink:href="#path-1"></use>
                                                            </mask>
                                                            <g id="Clip-5"></g>
                                                            <path
                                                                d="M7.497,9.89 C7.339,9.816 7.189,9.7 7.047,9.541 L0.339,2.196 C0.113,1.948 0,1.646 0,1.289 C0,1.06 0.054,0.846 0.16,0.649 C0.267,0.452 0.41,0.294 0.588,0.176 C0.766,0.059 0.968,0 1.194,0 C1.52,0 1.812,0.133 2.067,0.401 L8,6.943 L13.933,0.401 C14.183,0.133 14.474,0 14.806,0 C15.026,0 15.227,0.059 15.408,0.176 C15.589,0.294 15.733,0.452 15.84,0.649 C15.947,0.846 16,1.06 16,1.289 C16,1.646 15.887,1.948 15.662,2.196 L8.953,9.541 C8.811,9.694 8.662,9.809 8.508,9.885 C8.353,9.961 8.184,10 8,10 C7.822,10 7.654,9.963 7.497,9.89"
                                                                id="Fill-4" fill="#777777" mask="url(#mask-2)"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </template>
                            </ais-hits>
                            <div v-else>
                                <li>{{ translations.empty_search_results }}</li>
                            </div>
                        </div>
                    </template>
                </ais-state-results>
            </ais-instant-search>
        </div>
    </div>
</template>

<script>
import InstantSearch from 'vue-instantsearch';
import algoliasearch from 'algoliasearch/lite';
import searchInsights from 'search-insights';
import {createInsightsMiddleware} from 'instantsearch.js/es/middlewares'

Vue.use(InstantSearch);

const algoliaClient = algoliasearch(
    '2B39EOJ7MA',
    'ec01a73e818ec1e0f2d7ca9e1c640a70'
);

const searchClient = {
    algoliaClient,
    search(requests) {
        // When using the Insights middleware required for the GTM integration, the search function never gets called. This means we can't have the 2+ chars restriction implemented.
        if (requests.every(({params}) => (!params.query | params.query.length <= 2))) {
            return Promise.resolve({
                results: requests.map(() => ({
                    hits: [],
                    nbHits: 0,
                    nbPages: 0,
                    page: 0,
                    processingTimeMS: 0,
                    hitsPerPage: 0,
                    exhaustiveNbHits: false,
                    query: '',
                    params: '',
                })),
            });
        }

        console.info(requests);
        // {userToken: this.userToken}
        return algoliaClient.search(requests);
    },
    applicationID: '2B39EOJ7MA',
    apiKey: 'ec01a73e818ec1e0f2d7ca9e1c640a70',
};

searchInsights('init', {
    appId: '2B39EOJ7MA',
    apiKey: 'ec01a73e818ec1e0f2d7ca9e1c640a70',
    useCookie: true,
});

const insightsMiddleware = createInsightsMiddleware({
    insightsClient: searchInsights,
})

const debounce = function (func, wait, immediate) {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export default {
    name: "GlobalSearch",
    props: {
        indexEnv: String,
        searchIcon: String,
        translations: Object,
        stylingLocation: String,
    },
    data() {
        return {
            searchClient,
            userToken: '',
            searchIndex: '',
            currentGeo: this.fetchCurrentGeo(),
            searchValue: '',
            itemsFiltered: [],
            showingItemsIndex: 0,
            showingItemsLimit: 9,
            showFooter: false,
            showScrollPrev: false,
            showScrollNext: true,
            isUserBusySearching: false,
            isSearchBoxOpen: true, // navigation mode
            middlewares: [insightsMiddleware],
        };
    },
    created() {
        searchInsights('getUserToken', null, (err, value) => {
            if (err) {
                return;
            }
            this.userToken = value;
        });

        searchInsights('onUserTokenChange', (value) => {
            this.userToken = value;
        }, {immediate: true});
    },
    beforeMount() {
        this.searchIndex = `${this.indexEnv}_${this.currentGeo}`;
    },
    mounted() {
        this.registerOutsideClick();

        if (this.stylingLocation === 'navigation') {
            this.isSearchBoxOpen = false;
            this.toggleSearchOpenAndClose(false);
        }
    },
    methods: {
        fetchCurrentGeo: function () {
            return document.getElementById('global-nav') ? document.getElementById('global-nav').dataset.region.toLowerCase() : 'gb';
        },
        refineSearch: debounce(function (refine, value) {
            this.searchValue = value;
            refine(value);
            this.isUserBusySearching = this.searchValue.length >= 2;
        }, 300),
        scrollPrev: function () {
            let visibleHeight = $("#js-search-result").height();
            let currentScroll = $("#js-search-result").scrollTop();
            let scrollTo = Math.max(currentScroll - visibleHeight, 0);
            $("#js-search-result").scrollTop(scrollTo);
        },
        scrollNext: function () {
            let visibleHeight = $("#js-search-result").height();
            let currentScroll = $("#js-search-result").scrollTop();
            let maxScrollHeight = $("#js-search-list")[0].scrollHeight;
            let scrollTo = Math.min(currentScroll + visibleHeight, maxScrollHeight);
            $("#js-search-result").scrollTop(scrollTo);
        },
        onSearchResultScroll: function () {
            let currentScroll = $("#js-search-result").scrollTop();
            let visibleHeight = $("#js-search-result").height();
            let maxScrollHeight = $("#js-search-list")[0].scrollHeight;
            // if scrolled to the top - hide scroll prev
            this.showScrollPrev = currentScroll > 0;
            // if scrolled to the bottom - hide scroll next
            this.showScrollNext = (currentScroll + visibleHeight) < maxScrollHeight;
        },
        clearSearchValue: function () {
            this.searchValue = '';
            this.$refs.search.focus();
            this.isUserBusySearching = false;
            $('body').removeClass('noscroll-sm');
        },
        toggleSearchOpenAndClose: function (value, event) {
            this.searchValue = '';
            this.isUserBusySearching = false;

            if (value === false) {
                $('body').removeClass('noscroll-sm');
            }

            // do not toggle if we are not in the global nav
            if (this.stylingLocation !== 'navigation') {
                return;
            }

            value = (value === undefined ? !this.isSearchBoxOpen : value);

            this.isSearchBoxOpen = value;
            if (this.isSearchBoxOpen) {

                $('#js-global-nav-items-box').css('display', 'none');
                $('.global-search-container.navigation').removeClass('closed').addClass('opened');
            } else {
                $('body').removeClass('noscroll-sm');
                $('#js-global-nav-items-box').css('display', 'inline-block');
                $('.global-search-container.navigation').removeClass('opened').addClass('closed');
            }
        },
        registerOutsideClick: function () {
            document.addEventListener('mouseup',
                function (e) {
                    let container = $('.global-search-container');
                    if (!container.is(e.target) && container.has(e.target).length === 0) {
                        this.searchValue = '';
                        this.toggleSearchOpenAndClose(false);
                    }
                }.bind(this)
            );
        },
        resultsCheck(hits, query) {
            if (hits.length > 0) {
                this.showFooter = true;
                this.itemsFiltered = hits;
                this.showingItemsIndex = 0;
                this.isEmptyResultFromSearch = false;
                this.showScrollNext = this.itemsFiltered.length > 9;
                return true
            }

            if (query.length > 2) {
                this.trackSearchNoResults(query)
            }

            this.showFooter = false;
            return false;
        },
        trackSearchNoResults: function (query) {
            window.dataLayer.push({
                event: 'search-no-results',
                algoliaUserToken: this.userToken,
                query: query,
            });
        },
        trackSearchItemClick: function (query, item) {
            window.dataLayer.push({
                event: 'search-item-click',
                algoliaUserToken: this.userToken,
                query: query,
                page: item.title,
                url: item.path,
            });
        }
    }
}
</script>
